import {HttpClientModule} from '@angular/common/http';
import {CUSTOM_ELEMENTS_SCHEMA, NgModule} from '@angular/core';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import {HttpModule} from '@angular/http';
import {BrowserModule} from '@angular/platform-browser';
import {BrowserAnimationsModule} from '@angular/platform-browser/animations';
import {NgbModule} from '@ng-bootstrap/ng-bootstrap';
import {BowserModule, BowserService} from 'ngx-bowser';
import {environment} from '../../environments/environment';
import {AppRoutingModule} from './app-routing.module';
import {AppComponent} from './app.component';
import {AuthenticationRnecComponent} from './authentication-rnec/authentication-rnec.component';
import {AuthenticationRnecService} from './authentication-rnec/services/authentication-rnec.service';
import {BdbIdentityNumberComponent} from './bdb-identity-number/bdb-identity-number.component';
import {HealtyAppService} from './bdb-identity-number/services/healthy-app.service';
import {IdentificationTypeListService} from './bdb-identity-number/services/identification-type-list.service';
import {BdbRegulationProductsComponent} from './bdb-regulation-products/bdb-regulation-products.component';
import {BdbRegulationRnecComponent} from './bdb-regulation-rnec/bdb-regulation-rnec.component';
import {SessionTimeoutDirective} from './directives/session-timeout.directive';
import {PipesModule} from './pipes/pipes.module';
import {BdbCypherService, BdbEncryptService, BdbRequest, BdbSessionStrgService, BdbAuthLibModule} from '@npm-bbta/bbog-cm-auth-lib';
import {EventsService} from './shared/bdb-event.service';
import {BdbProductInfoService} from './shared/bdb-product-info.service';
import {ChannelService} from './shared/channel.service';
import {DispatcherService} from './shared/dispatcher.service';
import {FairService} from './shared/fair.service';
import {GoogleTagManagerService} from './shared/google-tag-manager.service';
import {LoginEventsService} from './shared/login-events.service';
import {ParticipantService} from './shared/participant.service';
import {RedirectService} from './shared/redirect.service';
import {OneTimePasswordService} from './bdb-one-time-password/services/bdb-otp.service';
import {BdbValidateOneTimePasswordComponent} from './bdb-one-time-password/validate-otp/bdb-validate-one-time-password.component';
import {BbdbTimerComponent} from './bdb-timer/bdb-timer.component';
import {WatchTimerModule} from './bdb-watch-timer';
import {BdbIdentityDirective} from './directives/bdb-identity-directive.directive';
import {AdviserService} from './shared/adviser.service';
import {BdbOlimpiaService} from './shared/bdb-olimpia.service';
import {MantizService} from './shared/mantiz.service';
import {BdbExpeditionDateComponent} from './bdb-expedition-date/bdb-expedition-date.component';
import {BdbRequestService} from './shared/bdb-request.service';
import {CypherService} from './shared/cypher.service';
import {BdbSecondFactorSelectorComponent} from './bdb-second-factor-selector/bdb-second-factor-selector.component';
import {BdbCifinConfrontaComponent} from './bdb-cifin-confronta/bdb-cifin-confronta.component';
import {BdbTokenComponent} from './bdb-token/bdb-token.component';
import {BdbSecurePasswordComponent} from './bdb-secure-password/bdb-secure-password.component';
import {BdbDebitCardPasswordComponent} from './bdb-debit-card-password/bdb-debit-card-password.component'
import {BdbCifinConfrontaService} from './bdb-cifin-confronta/services/bdb-cifin-confronta.service';
import {BdbErrorComponent} from './bdb-error/bdb-error.component';
import {SecurePasswordService} from './bdb-secure-password/services/secure-password.service';
import {PasswordsService} from './shared/passwords.service';
import {BdbDeviceIdService} from './shared/bdb-device-id.service';
import {ProcessAuthenticationService} from './shared/process-authentication.service';
import {BdbTokenAuthService} from './shared/bdb-token-auth.service';
import {BdbAbstentionService} from './shared/bdb-abstention.service';
import {SandboxUtilsService} from './shared/sandbox/sandbox-utils.service';
import {SandboxRequestService} from './shared/sandbox/sandbox-request.service';
import { BdbHandlerComponent } from './bdb-handler/bdb-handler.component';
import {SingleSessionService} from './shared/single-session.service';
import { IpUtil } from './shared/util/IpUtil';
import { AuthenticationRnecV2Component } from './authentication-rnec-v2/authentication-rnec-v2.component';
import { FingerprintUtil } from './shared/util/FingerprintUtil';
import { BdbBackdropComponent } from '../webcomponents/bdb-backdrop/bdb-backdrop.component';
import { BdbDialogoComponent } from '../webcomponents/bdb-dialogo/bdb-dialogo.component';
import { BdbErrorV2Component } from './bdb-error-v2/bdb-error-v2.component';
import { BdbErrorV2ModalComponent } from './bdb-error-v2-modal/bdb-error-v2-modal.component';
import { BdbBffService } from './shared/bdb-bff.service';
import { ErrorPageComponent } from './components/error-page/error-page.component';
import { AssistedStorage } from './shared/assistedStorage/assistedStorage';
import { SandboxService } from './shared/sandbox/sandbox.service';

@NgModule({
    declarations: [
        AppComponent,
        AuthenticationRnecComponent,
        BdbIdentityNumberComponent,
        BdbIdentityDirective,
        BdbRegulationProductsComponent,
        BdbRegulationRnecComponent,
        BbdbTimerComponent,
        BdbValidateOneTimePasswordComponent,
        SessionTimeoutDirective,
        BdbExpeditionDateComponent,
        BdbSecondFactorSelectorComponent,
        BdbCifinConfrontaComponent,
        BdbTokenComponent,
        BdbSecurePasswordComponent,
        BdbDebitCardPasswordComponent,
        BdbErrorComponent,
        BdbErrorV2Component,
        BdbErrorV2ModalComponent,
        BdbHandlerComponent,
        AuthenticationRnecV2Component,
        BdbBackdropComponent,
        BdbDialogoComponent,
        ErrorPageComponent
    ],
    imports: [
        ReactiveFormsModule,
        BrowserModule,
        BowserModule,
        AppRoutingModule,
        HttpClientModule,
        HttpModule,
        FormsModule,
        WatchTimerModule,
        NgbModule.forRoot(),
        PipesModule,
        BrowserAnimationsModule,
        BdbAuthLibModule.forRoot(environment),
    ],
    providers: [
        BdbRequest,
        BdbCypherService,
        AuthenticationRnecService,
        LoginEventsService,
        HealtyAppService,
        DispatcherService,
        BowserService,
        GoogleTagManagerService,
        FairService,
        EventsService,
        ParticipantService,
        BdbSessionStrgService,
        ChannelService,
        IdentificationTypeListService,
        BdbEncryptService,
        BdbProductInfoService,
        RedirectService,
        AdviserService,
        OneTimePasswordService,
        BdbOlimpiaService,
        MantizService,
        BdbRequestService,
        CypherService,
        BdbCifinConfrontaService,
        SecurePasswordService,
        PasswordsService,
        BdbDeviceIdService,
        ProcessAuthenticationService,
        BdbTokenAuthService,
        BdbAbstentionService,
        SandboxService,
        SandboxUtilsService,
        SandboxRequestService,
        SingleSessionService,
        IpUtil,
        FingerprintUtil,
        BdbBffService,
        AssistedStorage
    ],
    bootstrap: [AppComponent],
    schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class AppModule {
}



// WEBPACK FOOTER //
// ./src/app/app.module.ts